import React from "react";
import {
    isBotThinkingSelector,
    sendMessageToBot,
    VehicleDetails,
    websiteLocationSelector
} from "../../chatbotSlice";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {handleLinkInChatClick} from "../../chatbotUtil";

interface VehicleCardProps {
    vehicle: VehicleDetails
}

export const VehicleCard: React.FC<VehicleCardProps> = ({vehicle}) => {

    const dispatch = useAppDispatch()
    const thinking = useAppSelector(isBotThinkingSelector);
    const websiteLocation = useAppSelector(websiteLocationSelector);

    const handleLinkClick = (e: any) => {
        if (!!vehicle.redirect_url) {
            handleLinkInChatClick(e, vehicle.redirect_url, websiteLocation, false);
        } else {
            if (!thinking) {
                dispatch(sendMessageToBot("Tell me more about this vehicle"))
            }
        }
    }

    const getButtonTitle = (): string => {
        return !!vehicle.redirect_url ? "Open details" : "Tell me more"
    }

    return <div className="flex flex-col items-center text-base border-2 border-gray rounded-lg overflow-hidden">
        <div onClick={(e) => handleLinkClick(e)} className="cursor-pointer">
            <img
                src={vehicle.image_url && vehicle.image_url !== "" ? vehicle.image_url : "/no-image.jpeg"}
                alt={`${vehicle.make} ${vehicle.model} image`}
                className="w-full h-52 object-cover"
                style={{aspectRatio: '16 / 9'}}
            />
        </div>

        <div className="mt-5 mb-3 px-2 w-full bg-white">
            <div className="pl-1 pr-2">
                <div className="flex flex-row justify-between">
                    <h3 className="font-bold text-left">{vehicle.make ?? "No make"} {vehicle.model ?? "No model"}</h3>
                    <p className="text-right whitespace-nowrap">{vehicle.price ?? "£0"}</p>
                </div>
                <p className="text-start font-extralight">{vehicle.derivative ?? "No description"}</p>
            </div>
            <button
                onClick={(e) => handleLinkClick(e)}
                className="mt-2 py-2 px-6 font-semibold rounded-full hover:bg-gray-100 border-2 border-black w-full">
                {getButtonTitle()}
            </button>
        </div>
    </div>
}
